<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card card-custom gutter-b card-stretch">
          <!--begin::Header-->
          <div class="card-header border-0">
            <h3 class="card-title font-weight-bolder text-dark">{{$t('user_detail.change_history')}}</h3>
            <div class="card-toolbar">
              <b-button size="sm"><i class="fas fa-sync"></i> Listeyi Yenile</b-button>
            </div>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body pt-2">
            <div class="row">
              <div class="col-md-12">
                <b-table
                    :bordered="table.bordered"
                    :outlined="table.outlined"
                    :small="table.small"
                    :hover="table.hover"
                    :fixed="table.fixed"
                    :items="table.items"
                    :head-variant="table.headvariant"
                ></b-table>
              </div>
            </div>
          </div>
          <!--end::Body-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";

export default {
  name: "ChangeHistory",
  components: {DataTable},
  data() {
    return {
      form : {
      },
      table : {
        bordered : true,
        outlined : true,
        small : true,
        fixed : true,
        hover : true,
        headvariant : 'light',
        items: [
          { 'HistoryID': '90387755', 'ChangeDate': "22.11.2020", 'ColumnName': "Password", 'OldValue' : '1','NewValue': '2', 'ChangedBy' : '' },
          { 'HistoryID': '90387754', 'ChangeDate': "22.11.2020", 'ColumnName': "Ses2", 'OldValue' : '1','NewValue': '2', 'ChangedBy' : '' },
          { 'HistoryID': '90387753', 'ChangeDate': "22.11.2020", 'ColumnName': "Ses2", 'OldValue' : '1','NewValue': '2', 'ChangedBy' : '' },
          { 'HistoryID': '90387752', 'ChangeDate': "22.11.2020", 'ColumnName': "Facebook ID", 'OldValue' : '1','NewValue': '2', 'ChangedBy' : '' },
          { 'HistoryID': '90387751', 'ChangeDate': "22.11.2020", 'ColumnName': "GsmStatus", 'OldValue' : '1','NewValue': '2', 'ChangedBy' : '' },
          { 'HistoryID': '90387750', 'ChangeDate': "22.11.2020", 'ColumnName': "GsmNumber", 'OldValue' : '1','NewValue': '2', 'ChangedBy' : '' },
        ],
      },
    }
  },
};
</script>
